<template>
	<el-row :gutter="20" class="h-100">
		<el-col :span="8" class="h-100">
			<search-container :scrId="scrId" />
		</el-col>
		<el-col :span="16" class="h-100">
			<main-container v-if="show" :scrId="scrId" />
		</el-col>
	</el-row>
</template>

<script>
import SearchContainer from './Tree/SearchContainer.vue';
import MainContainer from './Table/MainContainer.vue';
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/SQLEditor/store/helpers';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components: {
		SearchContainer,
		MainContainer
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		show() {
			if (this.sqlContent.length != 0) {
				return true;
			} else {
				return false;
			}
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods
	},
	created() {}
};
</script>

<style></style>
